import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

// Pages are pre-rendered into static HTML at build time (scripts/prerender.js),
// so the browser paints real content before this bundle runs. We deliberately
// render() instead of hydrateRoot(): the snapshot can never match the live
// tree exactly (fresh API data, shuffled sponsored carousels), so hydration
// always failed with React #418/#423 and fell back to a client render anyway.
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
